export default __webpack_public_path__ + "static/formation-comprendre-da2fdc322dd96b9c7800cd64918e3170.png";